<template>
  <div class="file-card" @click="downloadFile(data)">
    <div class="file-info">
      <div class="file-name">{{ fileName + "." + extension }}</div>
      <div class="file-size">{{ fileSize }}</div>
    </div>
    <div class="file-image" :class="getType(data.content)"></div>
  </div>
</template>
<script>
export default {
  name: 'FileCard',
  props: {
    data: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {
      fileSize: 0,
      fileName: '',
      extension: ''
    };
  },
  created() {
    this.getFileNameAndExtension(this.data.content);
    this.getFileSizeNumer(this.data.content);
  },
  methods: {
    // 获取文件名和文件后缀
    getFileNameAndExtension(url) {
      const urlObj = new URL(url);
      const pathname = urlObj.pathname;
      const fileNameWithExtension = pathname.substring(
        pathname.lastIndexOf('/') + 1
      );
      this.fileName = fileNameWithExtension.split('.')[0];
      this.extension = fileNameWithExtension.split('.').pop();
    },
    /**
     * 获取文件类型
     */
    getType() {
      let type = '';
      switch (true) {
        case ['xlsx', 'xls'].includes(this.extension):
          type = 'excel';
          break;
        case ['docx', 'doc'].includes(this.extension):
          type = 'word';
          break;
        default:
      }
      return type;
    },
    /**
     * 获取文件大小
     */
    getFileSizeNumer(url) {
      var xhr = new XMLHttpRequest();
      xhr.open('HEAD', url, true);
      const that = this;
      xhr.onreadystatechange = function () {
        if (xhr.readyState === 4) {
          if (xhr.status === 200) {
            var size = xhr.getResponseHeader('Content-Length');
            that.getFileSize(size);
          }
        }
      };
      xhr.send();
    },
    getFileSize(fileSize) {
      if (!fileSize) {
        return '0 Bytes';
      }
      const unitArr = ['Bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'];
      const index = Math.floor(Math.log(fileSize) / Math.log(1024));
      const size = (fileSize / Math.pow(1024, index)).toFixed(2);
      this.fileSize = size + unitArr[index];
    },
    /**
     * 下载文件
     */
    downloadFile(data) {
      if (data?.content && data?.content.startsWith('http')) {
        const xhr = new XMLHttpRequest();
        xhr.open('GET', data.content, true);
        xhr.responseType = 'blob';
        xhr.onload = () => {
          const url = URL.createObjectURL(xhr.response);
          const link = document.createElement('a');
          link.style.display = 'none';
          link.href = url;
          link.setAttribute('download', decodeURIComponent(this.fileName));
          document.body.appendChild(link);
          link.click();
          URL.revokeObjectURL(url);
          document.body.removeChild(link);
        };
        xhr.send();
      }
    }
  }
};
</script>
<style lang="scss" scoped>
.file-card {
  display: flex;
  width: 260px;
  cursor: pointer;
  .file-info {
    overflow: hidden;
    flex: 1 1;
    margin-right: 10px;
    .file-size {
      color: #999;
      line-height: 30px;
    }
  }
  .file-image {
    width: 45px;
    height: 45px;
    background: no-repeat center / contain;
    &.excel {
      background-image: url("../../../common/image/icon_xlsx.png");
    }
    &.word {
      background-image: url("../../../common/image/icon_word.png");
    }
  }
}
</style>
